<!-- DAppCell，展示图标、名字、活跃用户数的小长条 -->

<template>
  <a class="dapp-cell">
    <div class="dapp-cell-container" :class="{'box-shadow-light': shadow}" @click="handleClick">
      <SimpleImage class="dapp-cell-logo" :src="dapp.logo" :placeholder="require('../static/round.png')"/>
      <span class="dapp-cell-name single-line">{{ dapp.name }}</span>
      <span class="dapp-cell-user single-line" v-if="userCount!==null">{{ userCount }}</span>
    </div>
  </a>
</template>

<script>
  import SimpleImage from './SimpleImage'
  import * as router from '../router'

  export default {
    name: 'DAppCell',
    components: {SimpleImage},
    props: ['dapp', 'userCount', 'shadow'],
    methods: {
      handleClick () {
        router.navigateToDApp(this.dapp)
      }
    }
  }
</script>

<style lang="scss" scoped>

  .dapp-cell {
    display: block;
  }

  .dapp-cell-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    background: white;

    > *:not(:first-child) {
      margin-left: 10px;
    }
  }

  .dapp-cell-logo {
    width: 30px;
    height: 30px;
  }

  .dapp-cell-name {
    flex-grow: 1;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/widgets/DAppCell.vue